module.exports = __webpack_public_path__ + "img/sr47_samurai01skin_shop.00612864.png";